import { render, staticRenderFns } from "./PracticeExtension.vue?vue&type=template&id=575b02de&scoped=true"
import script from "./PracticeExtension.vue?vue&type=script&lang=js"
export * from "./PracticeExtension.vue?vue&type=script&lang=js"
import style0 from "./PracticeExtension.vue?vue&type=style&index=0&id=575b02de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b02de",
  null
  
)

export default component.exports